import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import ShopDetailTable from '../../components/molecules/ShopDetailTable';
import CloseButton from '../../components/atoms/CloseButton';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  selectControl: {
    width: '100%'
  },
  selectContainer: {
    marginLeft: '40px',
    marginRight: '40px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('anniversaryPage', 'setAnniversaryPage', 0),
  withState('anniversaryRowsPerPage', 'setAnniversaryRowsPerPage', 5),
  withState('tagPage', 'setTagPage', 0),
  withState('tagRowsPerPage', 'setTagRowsPerPage', 5),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({
    handleChangeFollowPage: props => (event, followPage) => {
      props.setFollowPage(followPage);
    },
    handleChangeFollowRowsPerPage: props => event => {
      props.setFollowRowsPerPage(event.target.value);
    },
    handleChangeTagPage: props => (event, tagPage) => {
      props.setTagPage(tagPage);
    },
    handleChangeTagRowsPerPage: props => event => {
      props.setTagRowsPerPage(event.target.value);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    updateOpenDetailModal,
    roles,
    isLanguage,
    setIsLanguage
  }) => {
    const closeAction = () => updateOpenDetailModal(false);
    const multiLangDetail = { ...detail };
    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        Object.assign(multiLangDetail, languageData.params);
      }
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6">店舗情報詳細</Typography>
        <div className={classes.selectContainer}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
        </div>
        <div>
          <ShopDetailTable detail={multiLangDetail} roles={roles} />
        </div>
        <div>
          <CloseButton onClickAction={closeAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
